import React from 'react';
import { Dropdown, ButtonGroup } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import { useTheme } from '../../context/ThemeContext';
import { SUPPORTED_LANGUAGES } from '../../i18n/translations';

const LanguageThemeSelector = ({ variant = 'outline-secondary' }) => {
  const { language, setLanguage } = useLanguage();
  const { toggleTheme, isDark } = useTheme();

  const currentLang = SUPPORTED_LANGUAGES.find(l => l.code === language) || SUPPORTED_LANGUAGES[0];

  return (
    <div className="d-flex align-items-center gap-2">
      {/* Theme Toggle */}
      <button
        className={`btn ${variant} nav-pill-btn d-flex align-items-center justify-content-center`}
        onClick={toggleTheme}
        title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        style={{ width: '40px', height: '40px', padding: 0 }}
      >
        <i className={`bi ${isDark ? 'bi-sun-fill' : 'bi-moon-fill'}`}></i>
      </button>

      {/* Language Selector */}
      <Dropdown as={ButtonGroup}>
        <Dropdown.Toggle
          variant={variant.replace('btn-', '')}
          className="nav-pill-btn d-flex align-items-center gap-1"
        >
          {language.toUpperCase()}
          <i className="bi bi-chevron-down ms-1" style={{ fontSize: '0.7rem' }}></i>
        </Dropdown.Toggle>
        <Dropdown.Menu align="end">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <Dropdown.Item
              key={lang.code}
              active={language === lang.code}
              onClick={() => setLanguage(lang.code)}
            >
              {lang.flag} {lang.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LanguageThemeSelector;
